var $26f3f1b545fe7fe7$exports = {};
const $26f3f1b545fe7fe7$var$script = document.getElementById('app-module');
if ($26f3f1b545fe7fe7$var$script) {
    const url = $26f3f1b545fe7fe7$var$script.getAttribute('src');
    if (url) fetch(url, {
        method: 'HEAD'
    }).then((response)=>{
        if (!response.ok) throw new Error(`Could not read build metadata: ${response.status}`);
        const build = /[a-z0-9]+(?=\.js$)/i.exec(url)?.[0] ?? 'unknown';
        const modified = response.headers.get('Last-Modified');
        if (modified) console.info(`${build} ${new Date(modified).toLocaleString()}`);
    }).catch(()=>{
    // Build metadata is diagnostic only; failure must not affect the app.
    });
}


//# sourceMappingURL=karens2026.dbe4b21d.js.map
